/** Stub behavior for import entries */
export const enum Stub {
  noop,
  zero,
  enoent,
  ebadf,
  ebadf_neg,
  resize_heap,
  abort,
  cxa_throw,
  throw_longjmp,
  exit,
  date_now,
  environ_sizes_get,
}

/**
 * Configuration mapping minified WASM export/import names for an Emscripten-compiled module.
 * Consumers build this from their module-specific export enum (e.g. PdfiumExports).
 */
export type WasmExportConfig = {
  /** Minified import module name (e.g. "a") */
  readonly importModule: string
  /** Minified export name for WebAssembly.Memory */
  readonly memory: string
  /** Minified export name for malloc (undefined if not exported) */
  readonly malloc?: string
  /** Minified export name for free (undefined if not exported) */
  readonly free?: string
  /** Minified export name for __emscripten_stack_alloc (for stack-only modules) */
  readonly stackAlloc?: string
  /** Minified export name for __indirect_function_table */
  readonly indirectFunctionTable: string
  /** Minified export name for __wasm_call_ctors */
  readonly wasmCallCtors: string
  /** Minified export name for setThrew */
  readonly setThrew: string
  /** Minified export name for emscripten_stack_get_current */
  readonly stackGetCurrent: string
  /** Minified export name for _emscripten_stack_restore */
  readonly stackRestore: string
  /** Invoke wrappers: key=minified name, value=true if function returns a value */
  readonly invokes: Readonly<Record<string, boolean>>
  /** Syscall/fd/env stubs: key=minified name, value=stub behavior */
  readonly stubs: Readonly<Record<string, Stub>>
  /**
   * Additional import functions that may need access to the exports proxy.
   * Called with the mutable exports object so closures can reference memory, etc.
   * Return a record of minified-name -> import function.
   */
  readonly buildCustomImports?: (
    exports: Record<string, unknown>
  ) => Readonly<
    Record<string, (...args: number[]) => number | undefined | void>
  >
  /** Called after instantiation + __wasm_call_ctors, before returning instance */
  readonly onInit?: (exports: Record<string, unknown>) => void
}
